
import { defineStore } from 'pinia';
import { reactive } from 'vue';
import mushroom from "cem-primary-api";
import MethodService from "../service/MethodService";
import Data from "../views/don-vi-hanh-chinh/dataFormHanhChinh";

const tableRules = reactive(MethodService.copyObject(Data.tableRules));

export const DVHCStore = defineStore({
  id: 'dvhc',
  state: () => ({
    provinceData: [], // lấy dữ liệu tỉnh cho vào select
    districtDataArray: [],
    tableRulesDistrict: tableRules,
    idProvince: '',
  }),
  getters: {
    // code đổi data ở đây nhưng mà chưa biết viết kiểu gì
  },
  actions: {
    // lấy danh sách tỉnh
    async getProvince() {
      try {
        const response = await mushroom.province.getAllAsync();
        console.log("Các province thỏa mãn: %o, info: %o", response);
        if (response?.result.length > 0) {
          this.provinceData = [];
          response.result.forEach(province => {
            this.provinceData.push({
              value: province.id,
              label: province.type + " " + province.name,
              center: [province.center.lng, province.center.lat],
            });
          });
        }
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // lấy danh sách huyện
    async getDistrict() {
      let dataFilter = {
        filters: tableRules.filters,
        fields: "id,disabled,code,name,provinceId,index,type,center",
        limit: 1000,
        offset: tableRules.offset,
        sort: tableRules.sort,
      };
      try {
        const response = await mushroom.district.listAsync(dataFilter, { cacheAge: 1 });
        console.log("Các district thỏa mãn: %o, info: %o", response);
        if (response?.result.length > 0) {
          response.result.forEach(item => {
            item.fullNameProvince = item.type + " " + item.name
          })
          this.districtDataArray = response.result
          tableRules.total = response.meta.total;
          tableRules.page = response.meta.offset / response.meta.limit + 1;
        }
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // lấy danh sách huyện theo mã tỉnh
    // code here
    async getDistrictById(id) {
      console.log("id", id);
      try {
        const response = await mushroom.district.listAsync({
          provinceId: id
        });
        console.log("Thông tin district trả về: %o", response);
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async getProvinceById(id) {
      if (!id) {
        return;
      }
      try {
        const response = await mushroom.district.findByIdAsync({
          id: id
        });
        console.log("Thông tin district trả về: %o", response);
        if (response?.result?.provinceId) {
          try {
            const { result } = await mushroom.province.findByIdAsync({
              id: response.result.provinceId
            });
            this.idProvince = result?.id || "";
          }
          catch (e) {
            console.error("Có lỗi: %o", e);
          }
        }
        else {
          this.idProvince = "";
        }
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }

    }
  },
})

